import React, { useState, useEffect, useCallback } from "react";
import "./EnterEmail.css";
import { sendEmailOtp, verifyEmail } from "../../../api/auth";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import Loader from "../../Loader";
import { useNavigate } from "react-router-dom";

// debounce utility
function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

function EnterEmail() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  // email regex check
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // API call to check email
  const checkEmailAvailability = async (value) => {
    if (!validateEmail(value)) {
      setEmailError("Enter a valid email");
      setIsEmailValid(false);
      return;
    }

    setIsChecking(true);
    try {

      const response = await verifyEmail({ email: value });
      console.log("verify email response:", response);

      if (response.statusCode ===200 && response.success===true) {
        setEmailError(response.message || "Email is available!");
        setIsEmailValid(true);
        localStorage.setItem("email", response.data);
      }
      else if(response.statusCode ===403 && response.success===false) {
        setEmailError(response.message || "Email already exists & Verified");
        setIsEmailValid(false);
        console.log(response.message)
      } else{
        setEmailError(response.message || "verification failed!");
        setIsEmailValid(false);
      }
    } catch (error) {
      setEmailError(error.message || "Error verifying email");
      setIsEmailValid(false);
      console.error("error verifying email:", error.message);
    } finally {
      setIsChecking(false);
    }
  };

  // debounce the API call
  const debouncedCheckEmail = useCallback(debounce(checkEmailAvailability, 500), []);

  // trigger check on email change
  useEffect(() => {
    if (email) {
      debouncedCheckEmail(email);
    } else {
      setEmailError("");
      setIsEmailValid(false);
    }
  }, [email, debouncedCheckEmail]);

  const handlePrivacyPolicyClick = () => {
    navigate("/privacy-policy");
  };

  const handleTermsOfUseClick = () => {
    navigate("/terms-of-use");
  };

  
  const handleSendEmailOtp = async () => {
    setIsLoading(true);
    try {
      const response = await sendEmailOtp(email);
      console.log("send otp response:", response);
  
      if (response?.success || response?.statusCode === 200) {
        
        dispatch(setActiveComponent("emailOtpVerification")); 
      } else {
        setEmailError(response?.message || "Failed to send OTP");
      }
    } catch (error) {
      setEmailError(error?.message || "Error sending OTP");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="EnterEmail">
      <div className="enterEmailContainer">
        <div className="generalInputContainer">
          <label htmlFor="emailInput" className="labelText">
            Email
          </label>
          <div className="inputContainerWrapper">
            <input
              id="emailInput"
              className="input"
              type="text"
              placeholder="Type your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {isChecking && <Loader />}
            {emailError && (
              <span
                className={`errorTooltip ${isEmailValid ? "tooltipSuccess" : "tooltipError"}`}
              >
                {emailError}
              </span>
            )}
          </div>
        </div>

        <div className="checkboxContainer">
          <input
            type="checkbox"
            checked={agreed}
            onChange={() => setAgreed(!agreed)}
          />
          <label className="checkboxLabel">
            By signing up you agree to the{" "}
            <span className="irregularText" onClick={handleTermsOfUseClick}>
              terms of use
            </span>{" "}
            and{" "}
            <span className="irregularText" onClick={handlePrivacyPolicyClick}>
              privacy policy
            </span>
          </label>
        </div>

        <button
          className="btnContainer"
          disabled={!agreed || isLoading || !isEmailValid}
          onClick={handleSendEmailOtp}
        >
          {isLoading ? <Loader /> : <span className="btnText">Send Otp</span>}
        </button>
      </div>
    </div>
  );
}

export default EnterEmail;
